<template>
    <p>
        {{ $t('guide.guide_popover_step_1_desc') }}
    </p>
    <div :class="$style.img" @click="handleClick">
        <img v-if="account?.area === 'JP'" src="/images/guide_video_cover_jp.png" />
        <img v-else src="/images/guide_video_cover_en.png" />

        <div :class="$style.play">
            <pt-icon icon="pt-icon-asc"></pt-icon>
        </div>
    </div>
</template>

<script lang="ts" setup>
import useEventBus from '@assets/plugins/eventBus';
import { GuideStep } from '@master/store/guide.store';
import { useAccountInfo } from '@models/account/useAccountInfo';

interface Props {
    step: GuideStep;
}

const props = defineProps<Props>();
const emit = defineEmits(['video', 'hide', 'trackEvent']);

const { eventBus } = useEventBus();
const { account } = useAccountInfo();

function handleClick() {
    emit('video');
    emit('hide');
    emit('trackEvent', 'guide_video_click');

    eventBus.$emit('hideVerifyDialog');
    eventBus.$emit('hideSetup');
}
</script>

<style lang="scss" module>
@import '@style/import.scss';

.img {
    position: relative;
    cursor: pointer;
    margin-top: 12px;

    &:hover {
        box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.1);
    }

    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 32px;
        height: 32px;
        transform: translate(-50%, -50%);
        background: $pt-black-900;
        opacity: 0.8;
        border-radius: 50%;
    }

    img {
        max-width: 100%;
    }

    .play {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 45, 156, 0.38);
        border-radius: 4px;

        @extend %flex-center;

        svg {
            width: 14px;
            height: 14px;
            fill: $pt-white;
            transform: rotate(90deg);
            position: relative;
            z-index: 10;
        }
    }
}
</style>
